module.exports = __webpack_public_path__ + "img/ep1-16.ab9cfeb8.jpg";